// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: Roboto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #F4F5F7;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

ul, li {
    font-family: Roboto;
}

.ck {
  background-color: white;
  border-radius: 5px;
}

.ck-content {
  min-height: 250px;
}

.ck.ck-editor__editable_inline {
  border: 1px solid #C4C4C4 !important;
}

.button {
  all: unset;
  height: 48px;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 8px 16px;
  max-width: 300px;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .3s;
  background-color: #4F67F3;
  color: white;
}

.button:hover {
  color: white;
  background-color: #404FA1;
}

.button:focus {
  background-color: #7D8FF5;
}

.button + .button {
  margin-left: 16px;
}

.main {
  display: flex;
  flex-direction: column;
}

.apexcharts-legend {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mBAAmB;EACnB,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["body {\n  margin: 0;\n  font-family: Roboto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #F4F5F7;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nul, li {\n    font-family: Roboto;\n}\n\n.ck {\n  background-color: white;\n  border-radius: 5px;\n}\n\n.ck-content {\n  min-height: 250px;\n}\n\n.ck.ck-editor__editable_inline {\n  border: 1px solid #C4C4C4 !important;\n}\n\n.button {\n  all: unset;\n  height: 48px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  padding: 8px 16px;\n  max-width: 300px;\n  cursor: pointer;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: .3s;\n  background-color: #4F67F3;\n  color: white;\n}\n\n.button:hover {\n  color: white;\n  background-color: #404FA1;\n}\n\n.button:focus {\n  background-color: #7D8FF5;\n}\n\n.button + .button {\n  margin-left: 16px;\n}\n\n.main {\n  display: flex;\n  flex-direction: column;\n}\n\n.apexcharts-legend {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
